/** postMessage types for iframe auth sync with the parent business application */
export const AUTH_TOKENS_UPDATED = 'parent_auth_tokens_updated';
export const AUTH_REFRESH_REQUEST = 'parent_auth_refresh_request';
export const AUTH_REFRESH_RESPONSE = 'parent_auth_refresh_response';
export const AUTH_REFRESH_FAILED = 'parent_auth_refresh_failed';
export const AUTH_LOGOUT_REQUEST = 'parent_auth_logout_request';
